import { Injectable, inject } from '@angular/core'
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router'
import { filter, Observable } from 'rxjs'
import { OAuthService } from 'angular-oauth2-oidc'
import { UserService } from '../services/user.service'

@Injectable({
    providedIn: 'root',
})
export class AuthGuard {
    private oAuthService = inject(OAuthService);
    private router = inject(Router);
    private userService = inject(UserService);

    constructor() {
        const oAuthService = this.oAuthService;

        ;(window as any).oAuthService = oAuthService
    }

    // noinspection JSUnusedGlobalSymbols
    canActivate(
        route: ActivatedRouteSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        let validateQueryParam: string = route.queryParamMap.get('validate')
        if (this.oAuthService.hasValidIdToken()) {
            return true
        }

        return new Observable<boolean>((observer) => {
            this.oAuthService
                .tryLogin()
                .then(() => {
                    if (!this.oAuthService.hasValidIdToken()) {
                        this.oAuthService.initCodeFlow(validateQueryParam ? 'validate=' + validateQueryParam : null)
                    } else {
                        const state = route.queryParamMap.get('state')
                        if (state) {
                            const regex = /(?<=validate=)([^;]+)/
                            const validateMatch = RegExp(regex).exec(decodeURIComponent(state))
                            validateQueryParam = validateMatch ? validateMatch[1] : null
                        }
                        void this.router.navigate(['/'], {
                            skipLocationChange: false,
                            queryParams: validateQueryParam ? { validate: validateQueryParam } : {},
                        })

                        observer.next(true)
                        observer.complete()
                    }
                })
                .catch(() => {})
        })
    }

    // noinspection JSUnusedGlobalSymbols
    canActivateChild(
        childRoute: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        if (state.url === '/admin') {
            this.userService.fetchIsAdmin().subscribe()
            return this.userService.isAdmin.asObservable().pipe(filter((value) => value !== undefined))
        }

        return true
    }
}
